import { useState, useEffect } from 'react';
import axios from '../utils/axios';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { getLocalized } from '../utils/i18nHelpers';

const FAQ = () => {
  const { i18n } = useTranslation();
  const [faq, setFaq] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const { data } = await axios.get('/settings');
      setFaq(data.faq || []);
    } catch (error) {
      console.error('SSS yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 py-20">
        <h1 className="font-serif text-4xl md:text-5xl font-light tracking-wide text-center mb-4">
          Sıkça Sorulan Sorular
        </h1>
        <p className="text-center text-gray-600 font-light tracking-wide mb-16">
          En çok merak edilen sorulara buradan ulaşabilirsiniz
        </p>

        {faq.length === 0 ? (
          <div className="text-center py-12 text-gray-500 font-light">
            Henüz soru eklenmemiş
          </div>
        ) : (
          <div className="space-y-2">
            {faq.map((item, index) => (
              <div key={index} className="border-b border-gray-100">
                <button
                  onClick={() => toggleQuestion(index)}
                  className="w-full px-6 py-6 text-left flex items-center justify-between hover:bg-gray-50 transition"
                >
                  <span className="font-light text-gray-900 text-lg">
                    {getLocalized(item, 'question', i18n.language)}
                  </span>
                  {openIndex === index ? (
                    <FiChevronUp className="text-gray-900 flex-shrink-0 ml-4" />
                  ) : (
                    <FiChevronDown className="text-gray-400 flex-shrink-0 ml-4" />
                  )}
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-6">
                    <div
                      className="text-gray-600 font-light leading-relaxed prose prose-sm max-w-none"
                      dangerouslySetInnerHTML={{ __html: getLocalized(item, 'answer', i18n.language) }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQ;

